import { render } from "./ItemData.vue?vue&type=template&id=5087ec00"
import script from "./ItemData.vue?vue&type=script&lang=js"
export * from "./ItemData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__